/**
 * ACIL Intelligence - Error 403 (Forbidden)
 */
import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

export default function Error403() {
  return (
    <div className="error-page" data-testid="error-403-page">
      <ShieldOff size={48} color="var(--orange)" style={{ marginBottom: 16 }} />
      <div className="error-code">403</div>
      <div className="error-title">Acceso denegado</div>
      <div className="error-text">
        No tienes permisos para acceder a este recurso. Contacta a tu administrador si crees que es un error.
      </div>
      <Link to="/dashboard" className="btn-primary" style={{ textDecoration: 'none' }} data-testid="error-403-home-btn">
        Ir al dashboard
      </Link>
    </div>
  );
}
